var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('ColorPicker',_vm._b({ref:"color",staticClass:"visibility-hidden_picker",style:(_vm.getStyle),attrs:{"value":_vm.value,"preset-colors":_vm.recentColors},on:{"input":_vm.changeColor}},'ColorPicker',_vm.$props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }